import { Overline, Heading, Description, Link, Badge } from './CopyText';
import { CopyText, BadgeWrapper } from './CopyText.views';
CopyText.displayName = "CopyTextBase";
Overline.displayName = "CopyText.Overline";
Heading.displayName = "CopyText.Heading";
Description.displayName = "CopyText.Description";
Link.displayName = "CopyText.Link";
Badge.displayName = "CopyText.Badge";
BadgeWrapper.displayName = "CopyText.BadgeWrapper";
export { CopyText as default, Overline, Heading, Description, Link, Badge, BadgeWrapper };